import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { submitRequestDialogStyles as styles } from "../styles";

// Confirmation shown when a patch request drawer is closed with unsaved
// changes (backdrop click, Esc, ×, or Cancel).
const DiscardChangesDialog = ({ open, onKeepEditing, onDiscard }) => (
  <Dialog open={open} onClose={onKeepEditing} maxWidth="xs">
    <DialogTitle sx={styles.discardTitle}>Discard changes?</DialogTitle>
    <DialogContent>
      <Typography sx={styles.discardText}>
        You have unsaved changes in this form. Closing will discard them.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button
        variant="outlined"
        color="inherit"
        sx={styles.actionButton}
        onClick={onKeepEditing}
      >
        Keep editing
      </Button>
      <Button
        variant="contained"
        color="error"
        sx={styles.actionButton}
        onClick={onDiscard}
      >
        Discard
      </Button>
    </DialogActions>
  </Dialog>
);

export default DiscardChangesDialog;
